export default __webpack_public_path__ + "static/media/skilled_bee_icon.f3147bd4.svg";